<template>
	<div class="shadow-comp">
		<div class="shadow-comp-box">
			<div class="shadow-comp-tip">
				<div class="shadow-comp-title">{{title}}</div>
				<div class="shadow-comp-close" @click="shadowClose">关闭</div>
			</div>
			<div class="shadow-comp-info">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'ShadowComp',
		props:{
			title:{
				type:String,
				default:"信息编辑"
			}
		},
		data(){
			return{
				
			}
		},
		methods:{
			shadowClose(){
				this.$emit("shadow-close")
			}
		}
	}
</script>

<style>
	.shadow-comp{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #00000059;
		z-index: 999;
	}
	.shadow-comp-box{
		position: absolute;
		top: 160px;
		left: 600px;
		right: 420px;
		bottom: 160px;
		min-height: 400px;
		background-color: #FFFFFF;
		border-radius: 4px;
	}
	.shadow-comp-tip{
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #EEEEEE;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
		user-select: none;
	}
	.shadow-comp-info{
		padding: 10px;
		position: absolute;
		top: 50px;
		left: 10px;
		bottom: 10px;
		right: 10px;
		overflow: auto;
	}
	.shadow-comp-info > div{
		position: absolute !important;
		top: 0 !important;
		left: 0 !important;
		bottom: 0 !important;
		right: 0 !important;
		padding: 0 !important;
	}
</style>
